import { COLORS } from './chart.constant';

function shuffleArray(array) {
	const shuffledArray = array.slice();
	for (let i = shuffledArray.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		const temp = shuffledArray[i];
		shuffledArray[i] = shuffledArray[j];
		shuffledArray[j] = temp;
	}
	return shuffledArray;
}

function shuffleArray2(array) {
	const shuffledArray = array.slice();
	for (let i = shuffledArray.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 2));
		const temp = shuffledArray[i];
		shuffledArray[i] = shuffledArray[j];
		shuffledArray[j] = temp;
	}
	return shuffledArray;
}

const randomColors = shuffleArray(COLORS);
const randomColors2 = shuffleArray2(COLORS);

export const apexLineChartDefaultOption = {
	chart: {
		zoom: {
			enabled: false,
		},
		toolbar: {
			show: false,
		},
	},
	colors: [...COLORS],
	dataLabels: {
		enabled: false,
	},
	stroke: {
		width: 2.5,
		curve: 'smooth',
		lineCap: 'round',
	},
	legend: {
		itemMargin: {
			vertical: 10,
		},
		tooltipHoverFormatter: function (val, opts) {
			return val + ' - ' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + '';
		},
	},
	xaxis: {
		categories: [],
	},
};

export const apexAreaChartDefaultOption = { ...apexLineChartDefaultOption };

export const apexBarChartDefaultOption = {
	chart: {
		zoom: {
			enabled: false,
		},
		toolbar: {
			show: true,
		},
	},
	plotOptions: {
		bar: {
			horizontal: false,
			columnWidth: '50px',
			borderRadius: 2,
			distributed: true,
		},
	},
	colors: randomColors,
	dataLabels: {
		enabled: true,
	},
	stroke: {
		show: true,
		width: 6,
		curve: 'smooth',
		colors: ['transparent'],
	},
	legend: {
		show: false,
		itemMargin: {
			vertical: 10,
		},
		tooltipHoverFormatter: function (val, opts) {
			return val + ' - ' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + '';
		},
	},
	xaxis: {
		labels: {
			// show: false,
			// rotate: -45,
			fontSize: '12px',
		},
		categories: [],
		tickPlacement: 'on',
	},
	fill: {
		opacity: 1,
	},
	tooltip: {
		y: {
			formatter: (val) => `${val}`,
		},
	},
};

export const apexDonutChartDefaultOption = {
	colors: randomColors,
	plotOptions: {
		pie: {
			donut: {
				labels: {
					show: true,
					name: {
						show: false,
						fontSize: '22px',
						fontFamily: 'Helvetica, Arial, sans-serif',
						fontWeight: 600,
						color: undefined,
						offsetY: -10,
						formatter: function (val) {
							return val
						},
					},
					value: {
						show: true,
						fontSize: '20px',
						fontFamily: 'Montserrat',
						fontWeight: 600,
						formatter: function (val) {
							return val
						},
					},
					total: {
						show: false,
						showAlways: false,
						label: 'Total',
						fontSize: '22px',
						fontFamily: 'Helvetica, Arial, sans-serif',
						fontWeight: 600,
						color: '#373d3f',
						formatter: function (w) {
							return w.globals.seriesTotals.reduce((a, b) => {
								return a + b
							}, 0)
						},
					},
				},
				size: '60%',
			},
		},
	},
	stroke: {
		colors: ['white'],
	},
	labels: [],
	dataLabels: {
		enabled: false,
	},
	legend: {
		show: true,
		fontSize: 14,
	},
	responsive: [
		{
			breakpoint: 767,
			options: {
				chart: {
					height: 480,
				},
				legend: {
					position: 'bottom',
				},
			},
		},
	],
};

export const apexPieChartDefaultOption = {
	colors: randomColors2,
	plotOptions: {
		pie: {
			donut: {
				labels: {
					show: false,
				},
				size: '60%',
			},
		},
	},
	stroke: {
		colors: ['white'],
	},
	labels: [],
	dataLabels: {
		enabled: false,
	},
	legend: {
		show: true,
		fontSize: 14,
	},
	responsive: [
		{
			breakpoint: 767,
			options: {
				chart: {
					height: 480,
				},
				legend: {
					position: 'bottom',
				},
			},
		},
	],
};

export const apexSparklineChartDefaultOption = {
	chart: {
		type: 'line',
		sparkline: {
			enabled: true,
		},
	},
	stroke: {
		width: 2,
		curve: 'smooth',
	},
	tooltip: {
		fixed: {
			enabled: false,
		},
		x: {
			show: false,
		},
		y: {
			title: {
				formatter: () => '',
			},
		},
		marker: {
			show: false,
		},
	},
};
